import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { buttonVariants } from "@react/shared/ui/Button"
import { useDropdownMenu, MenuPanel, MENU_ITEM } from "@react/shared/ui/DropdownMenu"
import { t } from "../helpers/format"

const Option = ({ href, icon, title, hint, onClick }) => (
  <a href={href} onClick={onClick} className={`${MENU_ITEM} !items-start no-underline hover:no-underline`}>
    <FontAwesomeIcon icon={icon} className="mt-[3px]" />
    <span className="flex flex-col">
      <span>{title}</span>
      <span className="text-[11.5px] font-normal text-slate-500">{hint}</span>
    </span>
  </a>
)

const ExportMenu = ({ exportUrl }) => {
  const menu = useDropdownMenu({ width: 280, align: "right" })

  return (
    <>
      <button type="button" ref={menu.btnRef} className={buttonVariants({ variant: "secondary" })} onClick={menu.toggle}>
        <FontAwesomeIcon icon="file-excel" className="text-emerald-600" />
        {t("actions.export")}
        <FontAwesomeIcon icon="chevron-down" className="text-[10px] text-slate-400" />
      </button>
      {menu.open && (
        <MenuPanel menuRef={menu.menuRef} pos={menu.pos} width={menu.width}>
          <Option
            href    = {exportUrl("all")}
            icon    = "table-list"
            title   = {t("export.all")}
            hint    = {t("export.all_hint")}
            onClick = {menu.close}
          />
          <Option
            href    = {exportUrl("approved")}
            icon    = "circle-check"
            title   = {t("export.approved")}
            hint    = {t("export.approved_hint")}
            onClick = {menu.close}
          />
        </MenuPanel>
      )}
    </>
  )
}

export default ExportMenu
